import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { BannerSectionType01Component } from "../../banner-section/banner_section-type01/banner_section-type01.component";
import { ScrollerSectionType01Component } from "../../scroller-section/scroller_section-type01/scroller_section-type01.component";

@Component({
  selector: 'app-about-type02',
  standalone: true,
  imports: [MatIconModule, FuseCardComponent, HeadingSectionType01Component, BannerSectionType01Component, ScrollerSectionType01Component],
  templateUrl: './about-type02.component.html',
  styleUrl: './about-type02.component.scss'
})
export class AboutType02Component implements OnInit {

  public view: any = {
    title: ''
  }

  constructor(public _tfmService: TFMService, private meta: Meta, private title: Title) {
    
    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
    });
    
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);

      });
  }

  ngOnInit(): void {
      
  }
}
